import {Component, computed, inject, input} from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingService } from './loading.service';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
  loadingService = inject(LoadingService);
  force = input(false);
  forceText = input<string | null>(null);
  displayText = computed(
    () => this.forceText() ?? this.loadingService.loadingText()
  );
}
